import React, { useEffect, useState } from 'react';
import {
  Button,
  Drawer,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Checkbox,
  IconButton,
  Collapse,
  Box,
} from '@mui/material';
import controller from '../../../../assets/images/controller.svg';
import controllerActive from '../../../../assets/images/conroller_active.svg';
import emptyFolter from '../../../../assets/images/empty-folder 2.svg';
import createPopoverimg from '../../../../assets/images/createControllerPopover.svg';
import { useNavigate } from 'react-router-dom';
import { useHook as ControllerHook } from './useHook';
import { useHook as RoleHook } from '../../Iam/rolemanagement/useHook';
import { useSelector } from 'react-redux';
import { Unauthorized } from '../../../../components/index';
import { ErrorMessage } from '../../../../permissionErrorMessage/PermissionMessage';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import CreateSingleAlertModal from './createSingleAlertModal';
import UnsavedChangesPopup from './UnsavedChangesPopup';
const CreateAlert = ({
  formData,
  setFormData,
  alerts,
  setAlerts,
  formSubmit,
  handleSubmit,
  handleAddAlert,
  register,
  errors,
  editData,
  validationErrors,
  handleActiveChange,
  handleremoveError,
  fields,
  control,
  statusOptions,
  remove,
  editIndex,
  setEditIndex,
  append,
  reset,
  isActive,
  activeEditedData,
  setActiveEditedData,
  edit,
  isDirty
  ,watch
}: any) => {
  const navigate = useNavigate();
  const { allRole } = useSelector((state: any) => state.role);
  const { fetchGetAllRoleList } = RoleHook();
  const [controllerPage, setControllerPage] = useState('basicDetails');
  const [croppedImage, setCroppedImages] = useState<string | null>(null);
  const [createPopover, setCreatePopover] = useState(false);
  const [controllerPayload, setControllerPayload]: any = useState(null);
  const [isUnsavedChangesDialogOpen, setIsUnsavedChangesDialogOpen] =
    useState<any>(false);
  const handleUnsavedClose = () => {
    setIsUnsavedChangesDialogOpen(false);
  };

  //   const [editIndex, setEditIndex] = useState<number | null>(null);
  const [open, setOpen] = React.useState(false);

  const [openRows, setOpenRows] = useState<number[]>([]);

  const toggleRow = (index: number) => {
    setOpenRows((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };

  const submitParam = (data: any) => {
    const parameters = [
      {
        name: data?.name,
        type: data?.type,
        variableName: data?.variableName?.replace(/\s/g, ''),
        behaviour: data?.behaviour ? data?.behaviour : 'READ',
        accessPermissions: data?.accessPermissions,
        customerAccess: data?.customerAccess,
        comment: data?.comment,
      },
    ];
    if (!(editIndex === null)) {
      const updatedItems = [...alerts];
      updatedItems[editIndex] = {
        name: data?.name,
        type: data?.type,
        variableName: data?.variableName?.replace(/\s/g, ''),
        behaviour: data?.behaviour ? data?.behaviour : 'READ',
        accessPermissions: data?.accessPermissions,
        customerAccess: data?.customerAccess,
        comment: data?.comment,
      };
      setAlerts(updatedItems);
      setEditIndex(null);
    } else {
      setAlerts((prev: any) => [...prev, ...parameters]);
    }

    setFormData({
      name: '',
      type: '',
      variableName: '',
      behaviour: '',
      customerAccess: false,
      comment: '',
    });
    setOpen(false);
  };

  const submitdata = (data: any) => {
    const controllerPayload = {
      controllerName: data?.name,
      model: data?.model,
    };
    setControllerPayload(controllerPayload);

    controllerPage === 'basicDetails'
      ? setControllerPage('specifyParameters')
      : setControllerPage('basicDetails');
  };
  const handleAlertEdit = (editIndex: number) => {
    setEditIndex(editIndex);
    const EditData = alerts[editIndex];

    // open form prefilled with selected alert
    setFormData(EditData);
    reset(EditData);
    setOpen(true);
  };

  const handleAlertDelete = (deleteIndex: number) => {
    setAlerts((prev: any) =>
      prev.filter((_: any, idx: any) => idx !== deleteIndex),
    );
    setActiveEditedData((prev: any) => {
      const copy = { ...prev };
      delete copy[deleteIndex];
      return copy;
    });
  };

  const toggleDrawer = (newOpen: boolean) => {
    setOpen(newOpen);

    if (!newOpen) {
      console.log('closing drawer & resetting form');
      setEditIndex(null);
      reset({
        eventType: '',
        values: [{ value: '', title: '', desc: '', icon: '', channels: [] }],
      });
    }
  };

  return (
    <>
      <div className="create_controller_form create_controller_table">
        <TableContainer
          className="controller_table"
          component={Paper}
          sx={{ mb: 3 }}
        >
          <Table
            className={
              alerts?.length > 0
                ? 'fullwidthcontroller_table'
                : 'nodatacontroller_table'
            }
          >
            <TableHead className="controller_tableheader">
              <TableRow>
                <TableCell>Event Type</TableCell>
                {/* <TableCell align="right">Actions</TableCell> */}
                <TableCell align="right" />
              </TableRow>
            </TableHead>
            <TableBody>
              {alerts?.length > 0 ? (
                alerts?.map((alert: any, index: number) => (
                  <React.Fragment key={index}>
                    {/* Top-level row (eventType) */}
                    <TableRow>
                      {edit ? (
                        <TableCell>
                          <div
                            style={{
                              display: 'flex',
                              gap: '8px',
                              alignItems: 'center',
                            }}
                          >
                            {alert?.eventType}

                            {(activeEditedData[index]?.eventEdited ||
                              (activeEditedData[index]?.valuesEdited?.length ??
                                0) > 0) && (
                              <div className="active_edit_data-dot" />
                            )}
                          </div>
                        </TableCell>
                      ) : (
                        <TableCell>{alert?.eventType}</TableCell>
                      )}

                      <TableCell align="right">
                        <Button
                          className="btn-transparent border-0 img-background-form"
                          onClick={() => handleAlertEdit(index)}
                        >
                          <i
                            style={{
                              color: '#6c757d',
                              fontSize: '24px',
                            }}
                            className="edit-icon bi bi-pencil-square bi-lg"
                          ></i>
                        </Button>
                        <Button
                          color="error"
                          className="btn-transparent border-0 img-background-form"
                          onClick={() => handleAlertDelete(index)}
                        >
                          <i
                            style={{
                              color: '#6c757d',
                              fontSize: '24px',
                            }}
                            className="delete-icon bi bi-trash3-fill bi-lg"
                          ></i>
                        </Button>

                        <IconButton
                          size="small"
                          onClick={() => toggleRow(index)}
                        >
                          {openRows.includes(index) ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )}
                        </IconButton>
                      </TableCell>
                    </TableRow>

                    {/* Expandable details (values) */}
                    <TableRow>
                      <TableCell
                        colSpan={3}
                        style={{ paddingBottom: 0, paddingTop: 0 }}
                      >
                        <Collapse
                          in={openRows.includes(index)}
                          timeout="auto"
                          unmountOnExit
                        >
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center', // horizontally center
                              alignItems: 'center', // vertically center (if taller row)
                              width: '100%',
                              border:
                                '1px solid rgba(133, 143, 158, 0.3607843137)',
                              borderRadius: '8px',
                              marginTop: '16px',
                              marginBottom: '16px',
                            }}
                            // className="create_controller_form create_controller_table"
                          >
                            <Table
                              sx={{
                                borderCollapse: 'collapse',
                                width: '100%',
                              }}
                              className="fullwidthcontroller_table"
                            >
                              <TableHead className="controller_tableheader">
                                <TableRow>
                                  <TableCell>Value</TableCell>
                                  <TableCell>Title</TableCell>
                                  <TableCell>Description</TableCell>
                                  <TableCell>Icon</TableCell>
                                  <TableCell>Channels</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {alert.values.map((val: any, vIndex: any) => (
                                  <TableRow key={vIndex}>
                                    {edit ? (
                                      <TableCell>
                                        <div
                                          style={{
                                            display: 'flex',
                                            gap: '8px',
                                            alignItems: 'center',
                                          }}
                                        >
                                          {val.value}
                                          {activeEditedData[
                                            index
                                          ]?.valuesEdited?.includes(vIndex) && (
                                            <div className="active_edit_data-dot" />
                                          )}
                                        </div>
                                      </TableCell>
                                    ) : (
                                      <TableCell>{val.value}</TableCell>
                                    )}

                                    <TableCell>{val.title}</TableCell>
                                    <TableCell>{val.desc}</TableCell>
                                    <TableCell>
                                      {(() => {
                                        const option = statusOptions.find(
                                          (opt: any) => opt.value === val.icon,
                                        );
                                        if (!option) return null;
                                        return (
                                          <div
                                            style={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              gap: 2,
                                            }}
                                          >
                                            {option.icon}
                                            <span>{option.label}</span>
                                          </div>
                                        );
                                      })()}
                                    </TableCell>
                                    <TableCell>
                                      {val.channels
                                        .map((ch: string) => {
                                          switch (ch) {
                                            case 'db':
                                              return 'Store in Log';
                                            case 'push':
                                              return 'Push Notifications';
                                            case 'email':
                                              return 'Send an Email';
                                            default:
                                              return ch; // fallback in case of unexpected value
                                          }
                                        })
                                        .join(', ')}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </div>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))
              ) : (
                <></>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {alerts?.length > 0 && (
          <div className="create_controller-addparameter">
            <Button onClick={() => toggleDrawer(true)}>+ Add Event</Button>
          </div>
        )}
        <Drawer open={open} anchor="right" onClose={() => toggleDrawer(false)}>
          <CreateSingleAlertModal
          watch={watch}
          isDirty={isDirty}
            paramCloseDrawer={() => toggleDrawer(false)}
            paramSubmit={submitParam}
            formEditData={formData}
            formData={formData}
            setFormData={setFormData}
            formSubmit={formSubmit}
            alerts={alerts}
            reset={reset}
            setAlerts={setAlerts}
            editIndex={editIndex}
            setEditIndex={setEditIndex}
            statusOptions={statusOptions}
            handleSubmit={handleSubmit}
            handleAddAlert={handleAddAlert}
            register={register}
            errors={errors}
            editData={editData}
            validationErrors={validationErrors}
            handleActiveChange={handleActiveChange}
            handleremoveError={handleremoveError}
            fields={fields}
            control={control}
            remove={remove}
            append={append}
            isActive={isActive}
            toggleDrawer={toggleDrawer}
          />
        </Drawer>
        {!(alerts?.length > 0) && (
          <div className="create_controller-nodata">
            <img src={emptyFolter} alt="nodata" width="120" height="120" />
            <h3>No Record Found!</h3>
            <Button onClick={() => toggleDrawer(true)}>Add Event</Button>
          </div>
        )}

        <div className="create_controller_form-submit create_controller_table-submit">
          {edit ? (
  <Button
    onClick={() => {
      if (Object.keys(activeEditedData).length > 0) {
        // ✅ Unsaved changes exist → show dialog
        setIsUnsavedChangesDialogOpen(true);
      } else {
        // ✅ No unsaved changes → safe to navigate away
        navigate('/hardware/equipments');
      }
    }}
    className="create_controller_form-cancel-btn"
  >
    Cancel
  </Button>

          ) : (
            <Button
              onClick={() => navigate('/hardware/equipments')}
              className="create_controller_form-cancel-btn"
            >
    
            </Button>
          )}
          {edit ?
    <Button
         className={
                 Object.keys(activeEditedData).length > 0 
                    ? 'create_controller_form-submit-btn'
                    : 'disable_controller-btn'
                }
   
              type="submit"
              disabled={!isActive}
          

            onClick={() => {
              formSubmit(alerts);
            }}
         
          >
            Save Changes
          </Button>:
              <Button
            onClick={() => {
              formSubmit(alerts);
            }}
            className="create_controller_form-submit-btn"
          >
            Create
          </Button>
          }
      
        </div>
      </div>
      <UnsavedChangesPopup
        open={isUnsavedChangesDialogOpen}
        handleClose={handleUnsavedClose}
        handleNavigateClick={() => navigate('/hardware/equipments')}
      />
    </>
  );
};

export default CreateAlert;
